import { addStyles } from 'ethcss'
import { color, IStyles } from 'theme'

const canvasElementStyles: IStyles = {
    el: {
        position: 'absolute',
        boxSizing: 'border-box',
        cursor: 'move',
        border: '1px solid transparent',
        zIndex: 1,
        overflow: 'visible',
    },
    hitArea: {
        cursor: 'move',
        zIndex: 0,
    },
    elContent: {
        position: 'absolute',
        inset: 0,
        overflow: 'hidden',
        zIndex: 1,
    },
    selected: {
        borderColor: color.blue,
        boxShadow: `0 0 0 2px ${color.bgWhitePrimary}, 0 0 0 4px ${color.blue}`,
        zIndex: 2,
    },
    group: {
        background: 'transparent',
        borderStyle: 'dashed',
        overflow: 'visible',
    },
    locked: {
        cursor: 'default',
    },
}

addStyles(canvasElementStyles)
export default canvasElementStyles
